import React from 'react';
import { Container, Table } from 'react-bootstrap';
import { useDate, useLiveGames, usePage } from '../hooks';
import { FaCaretDown, FaCaretUp } from 'react-icons/fa';
import { get_page_events } from '../functions';
import { GridRow, Pager } from '.';
import logo from '../dark_logo.png';

const Grid = () => {
  const { date } = useDate();
  const { liveGames, totalGames } = useLiveGames();
 // const { page, totalPages } = usePage(60 * 1000, 10, totalGames);
  const { page, totalPages, setPage } = usePage(60 * 1000, 10, totalGames);
  if (!totalGames) return <div />;

  const page_events = get_page_events(liveGames, page);
  if (!Array.isArray(page_events) || page_events.length === 0) return <div />;
  if (!page_events?.length) return <div />;
  return (
    <Container fluid="fluid" className="p-0">
      <Table
        className="table table-borderless table-condensed table-striped"
        id="MatchTable"
        hover
        responsive
        striped
      >
        <thead>
          <tr className="tablehead">
            <th colSpan={3}><img src={logo} alt="Logo" width={150} /></th>
            <th colSpan={2}>{date.toLocaleString()}</th>
            <th colSpan={3} className="text-center">Match Odds</th>
            <th />
            <th colSpan={2} className="text-center">Under/Over</th>
            <th colSpan={2} className="text-center">Goal Goal</th>
            <th colSpan={3} className="text-center">Next&nbsp;Goal</th>
          </tr>
          <tr className="tablehead">
            <th colSpan={3} className="text-center" />
            <th className="matchStyle">Game</th>
            <th className="text-center">Score</th>
            <th className="text-center">1</th>
            <th className="text-center">X</th>
            <th className="text-center">2</th>
            <th className="text-center" />
            <th className="text-center">
              <FaCaretDown style={{ color: '#fff', fontSize: '25px' }} />
            </th>
            <th className="text-center">
              <FaCaretUp style={{ color: '#fff', fontSize: '25px' }} />
            </th>
            <th className="text-center">Yes</th>
            <th className="text-center">No</th>
            <th className="text-center">1</th>
            <th className="text-center">No Goal</th>
            <th className="text-center">2</th>
          </tr>
        </thead>

        <tbody className="fw-bold text-white">
        {page_events
    .filter(ev => ev && Array.isArray(ev.obj) && ev.obj[0])  // <- guard
    .map(ev => {
      const game = ev.obj[0];
      const rowKey = game?.std ?? game?.id ?? game?.key ?? Math.random().toString(36).slice(2);
      return <GridRow key={rowKey} event={ev} />;
    })}
        </tbody>
      </Table>

 
      <Pager
        page={page}
        totalPages={totalPages}
        onChange={(p) => setPage(p)}
      />
    </Container>
  );
};

export default Grid;
